<template>
    <div>
        <Header></Header>
        <Title></Title>
        <!--
        <div class="d-flex justify-center">
            <v-card flat style="width: 80%; max-width: 800px; margin: 10px">
                ああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああああ
            </v-card>
        </div>
        -->
        <div v-for="data in datas" :key="data.title">
            <div class="d-flex justify-center">
                <photo-card class="photo-card" :title="data.title" :photos="data.photos" :text="data.text" :key="data.key"></photo-card>
            </div>
            <div class="d-flex justify-center">
                <circles></circles>
            </div>
        </div>
        <prologue></prologue>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '../components/Header.vue'
    import Title from '../components/Title.vue'
    import PhotoCard from '../components/PhotoCard.vue'
    import Circles from '../components/Circles.vue'
    import Prologue from '../components/Prologue.vue'
    import Footer from '../components/Footer.vue'
    import datas from '../assets/data.json'

    export default {
        name: 'Aniversary',
        
        components: {
            Header,
            Title,
            PhotoCard,
            Circles,
            Prologue,
            Footer
        },

        data: function() {
            return {
                width: window.innerWidth,
                datas: datas
            }
        },

        computed: {
            resize: function() {
                if(this.width < 960)
                    return false
                return true
            }
        },

        methods: {
            handleResize: function() {
                this.width = window.innerWidth;
            },
        },

        mounted: function() {
            window.addEventListener('resize', this.handleResize)
        },

        beforeDestroy: function() {
            window.removeEventListener('resize', this.handleResize)
        }
    }
</script>

<style scoped>
.photo-card {
    width: 80%; 
    max-width: 800px;
}
.final-title {
    font-weight: bold;
    border-left: 10px solid #98494C;
}
</style>